import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { BiExport, BiImport } from "react-icons/bi";
import { retailerService } from "../../Services";
import Loader from "../../Components/Loader";
import { MdEdit } from "react-icons/md";
import { toast } from "react-toastify";

const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;
export function RetailerDetails() {
  const history = useHistory();
  let param = new URLSearchParams(history.location.search);
  let retailer_id = param.get("id");

  const [loader, setLoader] = useState(true);
  const [details, setDetails] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [retailerDutyTaxHeaders, setRetailerDutyTaxHeaders] = useState([]);
  const [retailerDutyTax, setRetailerDutyTax] = useState([]);

  useEffect(() => {
    getRetailerDetails();
    getStoreList();
    // eslint-disable-next-line
  }, []);

  const getRetailerDetails = () => {
    setLoader(true);
    const postData = {
      id: param.get("id"),
    };
    retailerService.getRetailerDetails(postData).then((res) => {
      if (res.status) {
        setDetails({
          type: res.data[0].type,
          tier: res.data[0].tier,
          profit_margin: res.data[0].profit_margin,
          retailer_name: res.data[0].retailer_name,
          retailer_type: res.data[0].retailer_type,
          contact_name: res.data[0].contact_name,
          phone_number: res.data[0].phone_number,
          retailer_email: res.data[0].retailer_email,
          referral_token: res.data[0].referral_token,
          retailer_token: res.data[0].retailer_token,
          total_discount: res.data[0].total_discount,
          customer_discount: res.data[0].customer_discount,
          store_discount: res.data[0].store_discount,
        });
        setLoader(false);
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };
  const getStoreList = () => {
    setLoader(true);
    let listData = {
      id: retailer_id,
    };
    retailerService.getStoreData(listData).then((res) => {
      if (res.status) {
        setStoreList(res.data);
        setLoader(false);
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };

  const getRetailerDutyTaxesList = () => {
    setLoader(true);
    let listData = { retailer_id: retailer_id };
    retailerService.getRetailerDutyTax(listData).then((res) => {
      if (res.status) {
        let data = res.data;
        let sheet_data = [["Hsn Code"], [""]];
        for (let i = 0; i < data.length; i++) {
          sheet_data[0].push(data[i].country_name);
          sheet_data[0].push("");
          sheet_data[1].push("Duty %");
          sheet_data[1].push("Tax %");
        }
        let hsnCodes = Array.from(
          new Set(
            data.flatMap((item) => item.duty_tax.map((dt) => dt.hsn_code))
          )
        );

        hsnCodes.forEach((hsnCode) => {
          let row = [hsnCode];
          data.forEach((country) => {
            let dutyTax = country.duty_tax.find(
              (dt) => dt.hsn_code === hsnCode
            );
            row.push(dutyTax ? dutyTax.duty : "", dutyTax ? dutyTax.tax : "");
          });
          sheet_data.push(row);
        });
        setRetailerDutyTax(sheet_data.slice(2));
        setRetailerDutyTaxHeaders(sheet_data.slice(0, 2));
        setLoader(false);
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };

  useEffect(() => {
    getRetailerDutyTaxesList();
  }, []);

  const onClickImport = (e) => {
    let formData = new FormData();
    formData.append("csv_file", e.target.files[0]);
    formData.append("retailer", retailer_id);
    retailerService.importRetailerDutyTax(formData).then((res) => {
      if (res.status) {
        getRetailerDutyTaxesList()
        setLoader(false);
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };

  const onClickExport = () => {
    let params = { retailer: retailer_id };
    retailerService.exportRetailerDutyTax(params).then((res) => {
      if (res.status) {
        window.location.href = REACT_APP_API_BASEURL + "/" + res.data;
        setLoader(false);
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };

  console.log(details, "details");

  return (
    <div className="container-fluid">
      <div className="white_box h-100">
        <div className="row">
          <div className="col-md-12 mb-4">
            <div className="row">
              <div className="row">
                <div className="col-md-12">
                  <div className="row mb-3">
                    <div className="col-lg-5 col-md-4 mb-6">
                      <div className="card p-3 h-100">
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Type - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.type}
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Retailer Name - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.retailer_name}
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Type of Retailer - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.retailer_type}
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Contact Person - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.contact_name}
                          </div>
                        </div>

                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Contact No. - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.phone_number}
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Email - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.retailer_email}
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Referral Code - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.referral_token}
                          </div>
                        </div>

                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Retailer Token - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.retailer_token}
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Tier - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.tier}
                          </div>
                        </div>
                        {
                          details && details.type === "marketplace" && 
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Profit Margin - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.profit_margin.split("_").join(" ")}
                          </div>
                        </div> ||
                        <>
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Total Discount - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.total_discount}
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Customer Discount - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.customer_discount}
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Store Discount - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.store_discount}
                          </div>
                        </div>
                        </>
                        }
                      </div>
                    </div>

                    {
                      details && details.type !== "marketplace" &&
                    <div className="col-lg-7 col-md-4 mb-6">
                      <div className="card p-3 h-100">
                        <div className="card-body">
                          <div className="d-flex justify-content-between mb-3">
                            <div>
                              {/* <input
                                type="text"
                                className={"form-control"}
                                placeholder="Search..."
                              /> */}
                            </div>
                            <button
                              className="btn btn-primary w-sm waves-effect waves-light"
                              onClick={() =>
                                history.push("/add-store?id=" + retailer_id)
                              }
                            >
                              Add Store
                            </button>
                          </div>
                          <div className="table-responsive">
                            <table className="table table-centered table-nowrap mb-0">
                              <thead className="table-light">
                                <tr>
                                  {/* <th>S no.</th> */}
                                  <th> Store Name</th>
                                  <th>Address</th>
                                  <th>Contact</th>
                                  <th>email</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {storeList.length > 0 &&
                                  storeList.map((item, key) => {
                                    return (
                                      <tr>
                                        <td>{item.store_name}</td>
                                        <td>{item.address}</td>
                                        <td>{item.phone_number}</td>
                                        <td>{item.store_email}</td>
                                        <td>
                                          <MdEdit
                                            className="pointer"
                                            onClick={() =>
                                              history.push(
                                                "/edit-store?id=" + item._id,
                                                item
                                              )
                                            }
                                            color="#0323fe"
                                            size="25px"
                                          />
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    }

                    {/* retailer duty tax  */}
                    {
                      details && details.type !== "marketplace" &&
                    <div className="col-lg-12 col-md-4 mt-4">
                      <div className="card p-2 h-100">
                        <div className="card-body">
                          <div className="d-flex justify-content-between mb-3">
                            <div className="fs-5 d-flex align-items-center  fw-bold">
                              Retailer duty and taxes
                            </div>
                            <div className="d-flex justify-content-end mb-3">
                              <input
                                type="file"
                                id="upload"
                                accept=".csv, .xlsx, .xls"
                                hidden
                                onChange={(e) => onClickImport(e)}
                              />
                              <label
                                for="upload"
                                className="btn btn-danger waves-effect waves-light mx-1 my-0"
                              >
                                <BiExport className="me-1 fs-5" />
                                Upload file
                              </label>
                              <div>
                                <button
                                  className="btn btn-success waves-effect waves-light mx-1 my-0"
                                  onClick={() => onClickExport()}
                                >
                                  <BiImport className="me-1 fs-5" />
                                  Download file
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="table-responsive">
                            {retailerDutyTaxHeaders && Array.isArray(retailerDutyTaxHeaders) && retailerDutyTaxHeaders.length > 0 
                            && retailerDutyTax && Array.isArray(retailerDutyTax) && retailerDutyTax.length>0 ? (
                              <table className="table table-centered table-nowrap mb-0 border text-center">
                                <thead className="table-light">
                                  {retailerDutyTaxHeaders.map((itm, index) => (
                                    <tr key={index}>
                                      {itm.map((item, i) => {
                                        if (i === 0 && index === 0) {
                                          return (
                                            <th rowSpan={2} key={i}>
                                              {item || "-"}
                                            </th>
                                          );
                                        } else if (index === 0) {
                                          if (item) {
                                            return (
                                              <th colSpan={2} key={i}>
                                                {item || "-"}
                                              </th>
                                            );
                                          }
                                          else{
                                            return null
                                          }
                                        } else {
                                          if (item) {
                                            return (
                                              <th key={i}>{item || "-"}</th>
                                            );
                                          }else{
                                            return null
                                          }
                                        }
                                      })}
                                    </tr>
                                  ))}
                                </thead>
                                <tbody>
                                  {retailerDutyTax.map((itm, index) => (
                                    <tr key={index}>
                                      {itm.map((item, i) => (
                                        <td key={i}>{item || "-"}</td>
                                      ))}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            ) : (
                              <div className="w-10 text-center mt-2">
                                Data Not Available
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Loader isShow={loader} />
    </div>
  );
}
